import { cn } from '@/lib/cn';
import { typographyVariant } from '@heidi/design-system/typography';
import { type ReactNode } from 'react';

interface ChoiceCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  onClick: () => void;
  'data-testid'?: string;
}

export function ChoiceCard({
  title,
  description,
  icon,
  onClick,
  'data-testid': testId,
}: ChoiceCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={cn(
        'flex w-full items-center gap-4 overflow-hidden rounded-xl border border-sand-150 bg-surface',
        'text-left transition-colors duration-200 ease-out',
        'hover:border-border-hover hover:bg-surface-hover',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus'
      )}
    >
      <div className="relative h-[98px] w-[127px] shrink-0">{icon}</div>
      <div className="flex min-w-0 flex-col gap-1 pr-4">
        <span className={typographyVariant({ variant: 'h4' })}>{title}</span>
        <span className={cn(typographyVariant({ variant: 'p2' }), 'text-text-secondary')}>
          {description}
        </span>
      </div>
    </button>
  );
}
